exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-item\r\n{\r\n    font-weight: bold;\r\n}\r\n.phase-button\r\n{\r\n    \r\n}\r\n.required-field\r\n{\r\n    color: red;\r\n    margin-right: 5px;\r\n    font-size: 10px;\r\n}\r\n.validation-error\r\n{\r\n    margin-right: 10px;\r\n    color: red;\r\n}\r\n.confirm\r\n{\r\n    color:green;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/order/deatils-of-order-for-supplier/details-of-order-for-supplier.component.css
// module id = ../../../../../src/app/order/deatils-of-order-for-supplier/details-of-order-for-supplier.component.css
// module chunks = main